import React from 'react';
import { string, number, array, shape, oneOfType } from 'prop-types';

// Import components
import ItemMetadata from './ItemMetadata';
import { AvailableIndication } from 'components/elements';

// Import utilities
import { useProductAvailability } from 'components/utilities';

const ItemDetails = ({
	data: { title, year, genres, rating, available_in, subtype, uuid }
}) => {
	const isAvailable = useProductAvailability({ uuid, available_in, subtype });

	return (
		<>
			{isAvailable && <AvailableIndication />}
			<ItemMetadata
				title={title}
				year={year}
				rating={rating}
				genres={genres && genres?.[0]?.name}
			/>
		</>
	);
};

ItemDetails.propTypes = {
	data: shape({
		title: string,
		year: number,
		genres: oneOfType([string, array]),
		rating: number,
		available_in: array,
		subtype: string,
		uuid: string
	}).isRequired
};

export default ItemDetails;
